import { render, staticRenderFns } from "./service_gtsh.vue?vue&type=template&id=16996b66"
import script from "./service_gtsh.vue?vue&type=script&lang=js"
export * from "./service_gtsh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports